export const STRINGS = {
  SUCCESS: "Success.",
  COMMON_ERROR: "Something went wrong."
}